import { qburstAppsUrl } from "../config";

export function isEmbeddedDashboard() {
  const path = window.location.pathname;
  return path.includes("embedded-dashboard");
}

export function isAccessedFromQBurstApps(): boolean {
  const url = qburstAppsUrl;
  console.log("url", url);
  

  if (!url) return false;

  try {
    const allowedHost = new URL(url).hostname;
    const currentHost = window.location.hostname;
    console.log("currentHost", currentHost);
    console.log("allowedHost", allowedHost);

    return currentHost === allowedHost || currentHost.endsWith(`.${allowedHost}`);
  } catch {
    return false;
  }
}
